/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import setTransition from 'app/_shared/events/util/setTransition'

/**
 * Update Event Handler
 *
 * Initializes an UI update. Enables or disables transition animations
 * based on `transition`.
 *
 * @param {boolean} transition              whether to enable/disable transition animations
 * @param {Gaia.AppModule.Spec} module      the current module composition object
 * @param {Gaia.Component.Spec} component   the current action's main component
 * @param {Gaia.PlatformEvent} event        the event object that triggered this handler
 * @returns {Promise<void>}
 */
const update = async (transition, module, component, event) => {
  setTransition(transition, module, component, event)
  await module[G.ADAPTER][G.UI].update(module)
}

/**
 * Update With Transition Event Handler
 *
 * Initializes an UI update, triggering potential transition animations.
 *
 * @param {Gaia.AppModule.Spec} module      the current module composition object
 * @param {Gaia.Component.Spec} component   the current action's main component
 * @param {Gaia.PlatformEvent} event        the event object that triggered this handler
 * @returns {Promise<void>}
 */
export const updateWithTransistion = async (module, component, event) => await update(true, module, component, event)

/**
 * Update Event Handler
 *
 * Initializes an UI update without triggering potential transition animations.
 *
 * @param {Gaia.AppModule.Spec} module      the current module composition object
 * @param {Gaia.Component.Spec} component   the current action's main component
 * @param {Gaia.PlatformEvent} event        the event object that triggered this handler
 * @returns {Promise<void>}
 */
const updateWithoutTransistion = async (module, component, event) => await update(false, module, component, event)

export default curry(updateWithoutTransistion)
